import request from "@/network/request"

// 查询微信公众号膳食处方支付信息
export function requestGuidance(data) {
	return request({
		url: "/api/nutrition/provide/order/details",
		method: 'post',
		data,
	});
}